import React from "react";
import { Layout } from "antd";

export const Wrapper: React.FC = ({ children }) => (
  <Layout className="atticus-editor-layout">
    {children}
  </Layout>
);